import { message } from "antd";
import {
	POST_POLICY_HOLDER_AUTH,
	CUSTOMER_PORTAL_QUOTES,
	SEND_PORTAL_ACCESS_LINK,
	CUSTOMER_PORTAL_SEND_DOCUMENTS,
} from "../configs/api-paths";
import BaseService from "./base/BaseService";
import { fetchResource } from "../utilities";
import { action, makeObservable, observable } from "mobx";

/**
 * Service dealing with Customer Portal.
 */
class CustomerPortalService extends BaseService {
	@observable
	customerAuthorized = false;

	@observable
	customerTokenExpiresOn;

	@observable
	customerEmail;

	@observable
	customerName;

	@observable
	customerQuotes = [];

	constructor(props) {
		super(props);
		makeObservable(this);
	}

	@action
	setCustomerAuthorized = (data) => {
		this.customerAuthorized = data;
	};

	@action
	setCustomerTokenExpiresOn = (data) => {
		this.customerTokenExpiresOn = data;
	};

	@action
	setCustomerEmail = (data) => {
		this.customerEmail = data;
	};

	@action
	setCustomerName = (data) => {
		this.customerName = data;
	};

	@action
	setCustomerQuotes = (data) => {
		this.customerQuotes = data;
		if (this.customerQuotes && this.customerQuotes.length !== 0) {
			const customerName = `${this.customerQuotes[0].organisation.first_name} ${this.customerQuotes[0].organisation.last_name}`;
			this.setCustomerName(customerName);
		}
	};

	validateAccess = async (token) => {
		const authRequest = {
			token: token,
		};

		let hideLoadingMessage = message.loading("Authorizing...", 0);

		try {
			const result = await fetchResource(POST_POLICY_HOLDER_AUTH, {
				method: "POST",
				body: authRequest,
			});
			const response = await result.json();
			this.setCustomerAuthorized(response.validity);
			this.setCustomerEmail(response.email);
			this.setCustomerTokenExpiresOn(response.expiresOn);
//			message.success("Successfully gained access to customer portal", 5);
			hideLoadingMessage();
		} catch (error) {
			hideLoadingMessage();
			this.setCustomerAuthorized(false);
		}
	};

	sendPortalAccessLink = async (email) => {
		let hideLoadingMessage = message.loading("Sending access link...", 0);
		const url = SEND_PORTAL_ACCESS_LINK + "?email=" + email;

		try {
			const response = await fetchResource(url);
			if (response.ok)
				message.success("Access link will be sent to: " + email, 10);
			hideLoadingMessage();
		} catch (error) {
			hideLoadingMessage();
		}
	};

	sendDocuments = async (policyNumber) => {
		let hideLoadingMessage = message.loading("Sending documents...", 0);

		try {
			const url = CUSTOMER_PORTAL_SEND_DOCUMENTS.replace(
				"{policyNumber}",
				policyNumber
			);
			const response = await fetchResource(url, {
				method: "PATCH",
			});
			if (response.ok)
				message.success("Documents will be sent to " + this.customerEmail, 10);
			hideLoadingMessage();
		} catch (error) {
			hideLoadingMessage();
			message.error("Failed generating documents", 5);
		}
	};

	loadQuotes = async () => {
		let hideLoadingMessage = message.loading("Loading quotes...", 0);

		try {
			const url = CUSTOMER_PORTAL_QUOTES.replace("{email}", this.customerEmail);
			const result = await fetchResource(url);
			const quotesResponse = await result.json();
			hideLoadingMessage();
			this.setCustomerQuotes(quotesResponse);
		} catch (error) {
			hideLoadingMessage();
			message.error("Failed loading quotes", 5);
		}
	};

	logout() {
		this.setCustomerAuthorized(false);
		this.setCustomerTokenExpiresOn(undefined);
		this.setCustomerEmail(undefined);
		this.setCustomerName(undefined);
		this.setCustomerQuotes(undefined);
	}
}

export default CustomerPortalService;
